(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactScreenSize"] = factory(require("react"));
	else
		root["ReactScreenSize"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _connectScreenSize = __webpack_require__(2);

	Object.defineProperty(exports, 'connectScreenSize', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_connectScreenSize).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(3);

	var _react2 = _interopRequireDefault(_react);

	var _provider = __webpack_require__(4);

	var _provider2 = _interopRequireDefault(_provider);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var connectScreenSize = function connectScreenSize(mapScreenToProps) {
	  return function (ComposedComponent) {
	    var ConnectScreenSize = function (_React$PureComponent) {
	      _inherits(ConnectScreenSize, _React$PureComponent);

	      function ConnectScreenSize(props) {
	        _classCallCheck(this, ConnectScreenSize);

	        var _this = _possibleConstructorReturn(this, (ConnectScreenSize.__proto__ || Object.getPrototypeOf(ConnectScreenSize)).call(this, props));

	        _initialiseProps.call(_this);

	        _this.state = { computedProps: _this.computeScreenSizeProps(props) };
	        return _this;
	      }

	      _createClass(ConnectScreenSize, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.unsubscribe = _provider2.default.subscribe(this.updateComputedProps);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this.unsubscribe) this.unsubscribe();
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state.computedProps));
	        }
	      }]);

	      return ConnectScreenSize;
	    }(_react2.default.PureComponent);

	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;

	      this.computeScreenSizeProps = function (props) {
	        return mapScreenToProps(_provider2.default.getScreenSize(), props);
	      };

	      this.updateComputedProps = function () {
	        _this2.setState({ computedProps: _this2.computeScreenSizeProps(_this2.props) });
	      };
	    };

	    return ConnectScreenSize;
	  };
	};

	exports.default = connectScreenSize;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _medias = __webpack_require__(5);

	var _medias2 = _interopRequireDefault(_medias);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Provider = function () {
	  function Provider() {
	    _classCallCheck(this, Provider);

	    this.listeners = [];
	    this.setup();
	  }

	  _createClass(Provider, [{
	    key: 'getScreenSize',
	    value: function getScreenSize() {
	      return this.screenSize;
	    }
	  }, {
	    key: 'bootstrap',
	    value: function bootstrap(matchMedia) {
	      var _this = this;

	      this.mediaQueryLists = {};

	      Object.keys(_medias2.default).forEach(function (query) {
	        _this.mediaQueryLists[_medias2.default[query]] = matchMedia(query);
	      });

	      Object.keys(_medias.greaterThanMedias).forEach(function (query) {
	        _this.mediaQueryLists[_medias2.default[query]].addListener(function () {
	          return _this.update();
	        });
	      });

	      this.update();
	    }
	  }, {
	    key: 'setup',
	    value: function setup() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          mobile = _ref.mobile,
	          tablet = _ref.tablet;

	      var isMobile = mobile;
	      var isTablet = !isMobile && tablet;
	      var isDesktop = !isMobile && !isTablet;
	      this.screenSize = {
	        'mobile': isMobile,
	        '> mobile': isTablet || isDesktop,
	        'small': isTablet,
	        '> small': isDesktop,
	        'medium': isDesktop,
	        '> medium': isDesktop,
	        'large': false,
	        '> large': false
	      };
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var _this2 = this;

	      this.screenSize = Object.assign({}, this.screenSize);
	      Object.keys(this.screenSize).forEach(function (key) {
	        _this2.screenSize[key] = _this2.mediaQueryLists[key].matches;
	      });
	      this.listeners.forEach(function (listener) {
	        return listener();
	      });
	    }
	  }, {
	    key: 'subscribe',
	    value: function subscribe(listener) {
	      var _this3 = this;

	      this.listeners.push(listener);
	      return function () {
	        _this3.listeners.splice(_this3.listeners.indexOf(listener), 1);
	      };
	    }
	  }]);

	  return Provider;
	}();

	var provider = new Provider();

	if (typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined') {
	  provider.bootstrap(window.matchMedia);
	}

	exports.default = provider;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var greaterThanMedias = exports.greaterThanMedias = {
	  '(min-width: 601px)': '> mobile',
	  '(min-width: 961px)': '> small',
	  '(min-width: 1281px)': '> medium',
	  '(min-width: 1921px)': '> large'
	};

	var strictMedias = exports.strictMedias = {
	  '(max-width: 600px)': 'mobile',
	  '(max-width: 960px) and (min-width: 601px)': 'small',
	  '(max-width: 1280px) and (min-width: 961px)': 'medium',
	  '(max-width: 1920px) and (min-width: 1281px)': 'large'
	};

	exports.default = _extends({}, greaterThanMedias, strictMedias);

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-screen-size/lib/index.js
// module id = 146
// module chunks = 0